"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentId = void 0;
var ExperimentId;
(function (ExperimentId) {
    // e.g. SHARED_WEB_NEW_NAV_MAP_DESKTOP in
    // https://ab.sc-corp.net/v2/experiment/SHARED_WEB_LOCALIZATION
    ExperimentId["SHARED_WEB_LOCALIZATION"] = "SHARED_WEB_LOCALIZATION";
    ExperimentId["CONSOLIDATE_FOOTER_EXPERIMENT_ID"] = "WEB_CONSOLIDATE_FOOTER";
})(ExperimentId = exports.ExperimentId || (exports.ExperimentId = {}));
//# sourceMappingURL=experiment.js.map